import produce from 'immer';

import {
  CASE_ROLES_FETCH_FAILURE,
  CASE_ROLES_FETCH_SUCCESS,
  CONTACT_EDIT_FAILURE,
  CONTACT_EDIT_SUCCESS,
  CONTACT_FETCH_FAILURE,
  CONTACT_FETCH_SUCCESS,
  CONTACT_ID_FETCH_FAILURE,
  CONTACT_ID_FETCH_SUCCESS,
  CONTACTS_CLEAR,
  CONTACTS_FETCH_FAILURE,
  CONTACTS_FETCH_SUCCESS,
  DUPLICATE_CONTACTS_FAILURE,
  DUPLICATE_CONTACTS_SUCCESS,
  FETCH_CONTACT_SUGGESTIONS_FAILURE,
  FETCH_CONTACT_SUGGESTIONS_SUCCESS,
  FETCH_CONTACTS_LIST_FAILURE,
  FETCH_CONTACTS_LIST_SUCCESS,
  FETCH_EXTERNAL_CONTACTS_FAILURE,
  FETCH_EXTERNAL_CONTACTS_SUCCESS,
  FETCH_MATCHING_CONTACTS_FAILURE,
  FETCH_MATCHING_CONTACTS_REQUEST,
  FETCH_MATCHING_CONTACTS_SUCCESS,
  LOAD_MORE_CONTACTS,
  SET_DRAFT_CONTACTS,
  SUGGESTED_CONTACTS_CLEAR,
} from '@actions/contact';

const initialState: IContactStore = {
  contacts: null,
  duplicateContacts: null,
  suggestedContacts: null,
  draftContacts: null,
  contactList: null,
  currentContact: null,
  caseRoles: null,
  isFetching: false,
  contactId: null,
  contactType: null,
  externalContact: null,
  error: null,
  matchingContacts: [],
  isFetchingMatchingContacts: false,
};

export default (state: IContactStore = initialState, action: any) =>
  produce(state, (draftState: IContactStore) => {
    switch (action.type) {
      case CONTACTS_FETCH_SUCCESS:
        draftState.contacts = action.response;
        draftState.error = null;

        return;

      case CONTACTS_FETCH_FAILURE:
        draftState.contacts = null;
        draftState.error = action.error;

        return;
      case FETCH_CONTACTS_LIST_SUCCESS:
        draftState.contactList = action.response;
        draftState.error = null;

        return;
      case LOAD_MORE_CONTACTS:
        const { data, selectedContacts } = action.response;
        draftState.contactList.data = draftState.contactList.data.concat(data);
        draftState.contactList.selectedContacts = selectedContacts;
        draftState.error = null;

        return;

      case FETCH_CONTACTS_LIST_FAILURE:
        draftState.contactList = null;
        draftState.error = action.error;

        return;
      case DUPLICATE_CONTACTS_SUCCESS:
        draftState.duplicateContacts = action.response;
        draftState.error = null;

        return;

      case DUPLICATE_CONTACTS_FAILURE:
        draftState.duplicateContacts = null;
        draftState.error = action.error;

        return;

      case CASE_ROLES_FETCH_SUCCESS:
        draftState.isFetching = false;
        draftState.caseRoles = action.response;
        draftState.error = null;

        return;

      case CASE_ROLES_FETCH_FAILURE:
        draftState.isFetching = false;
        draftState.caseRoles = null;
        draftState.error = action.err;

        return;

      case CONTACTS_CLEAR:
        draftState.contacts = null;

        return;

      case SUGGESTED_CONTACTS_CLEAR:
        draftState.suggestedContacts = null;

        return;
      case SET_DRAFT_CONTACTS:
        draftState.draftContacts = action.draftContacts;

        return;
      case CONTACT_FETCH_SUCCESS:
      case CONTACT_EDIT_SUCCESS:
        draftState.currentContact = action.response;
        draftState.error = null;

        return;

      case CONTACT_EDIT_FAILURE:
        draftState.error = action.error;

        return;

      case CONTACT_FETCH_FAILURE:
        draftState.currentContact = null;
        draftState.error = action.error;

        return;

      case FETCH_CONTACT_SUGGESTIONS_SUCCESS:
        draftState.suggestedContacts = action.response;
        draftState.error = null;

        return;

      case FETCH_CONTACT_SUGGESTIONS_FAILURE:
        draftState.suggestedContacts = null;
        draftState.error = action.error;

        return;

      case CONTACT_ID_FETCH_SUCCESS:
        draftState.contactId = action.response.contactId;
        // contactType may not be present in older API responses, so handle gracefully
        draftState.contactType = action.response.contactType || null;
        draftState.error = null;

        return;

      case CONTACT_ID_FETCH_FAILURE:
        draftState.contactId = null;
        draftState.contactType = null;
        draftState.error = action.error;

        return;

      case FETCH_EXTERNAL_CONTACTS_SUCCESS:
        draftState.externalContact = action.response;
        draftState.error = null;

        return;

      case FETCH_EXTERNAL_CONTACTS_FAILURE:
        draftState.error = action.error;
        draftState.externalContact = null;

        return;

      case FETCH_MATCHING_CONTACTS_REQUEST:
        draftState.isFetchingMatchingContacts = true;

        return;

      case FETCH_MATCHING_CONTACTS_SUCCESS:
        draftState.matchingContacts = action.response;
        draftState.isFetchingMatchingContacts = false;
        draftState.error = null;

        return;

      case FETCH_MATCHING_CONTACTS_FAILURE:
        draftState.matchingContacts = [];
        draftState.isFetchingMatchingContacts = false;
        draftState.error = action.error;

        return;
    }
  });
